export default "__VITE_ASSET__CsM3ytir__"